export const USER_PREFIX = '@user/';
export const USER_ALLOC_WALLET = `${USER_PREFIX}ALLOC_WALLET`;
export const USER_CHECK_WALLET = `${USER_PREFIX}CHECK_WALLET`;
export const USER_FETCH = `${USER_PREFIX}FETCH`;
export const USER_UPDATE = `${USER_PREFIX}UPDATE`;
export const USER_UPDATE_DATA = `${USER_PREFIX}UPDATE_DATA`;
export const USER_RESET_UPDATED = `${USER_PREFIX}RESET_UPDATED`;
